module.exports = __webpack_public_path__ + "static/media/origin-regs-logo.b16a1143.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/origin-regs-logo.png
// module id = 936
// module chunks = 0